module.exports = __webpack_public_path__ + "img/ng.c0bf7d8f.svg";